import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import $ from "jquery";

import Server from '../../../../functions/server';
import Loading from '../../../loading';
import Transfer from '../transfer';
import ViewRequestInItems from '../viewrequestitems';

const styles = theme => ({
  form: { display: 'flex', flexDirection: 'column', margin: 'auto', width: 'fit-content' },
  formControl: { marginTop: theme.spacing.unit * 2, minWidth: 120 },
  formControlLabel: { marginTop: theme.spacing.unit },
});

class Request extends React.Component {
  state = {
    open: false, fullWidth: true,
    maxWidth: 'xl', requestitems: []
  };

  componentDidMount() {
    this.getRequestItems();
  }

  getRequestItems() {
    let context = this;
    this.setState({ load: true, message: 'Getting Request Items' })
    let branch = this.props.selectedBranch;
    $.ajax({
      type: 'POST',
      data: { 'branch': branch },
      url:Server() + 'stocktransferrequest/getrequestin.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ requestitems: data, load: false })
        } catch (e) { context.setState({ load: false }) }
      },
      error: function(err) {
        context.setState({ load: false })
      }
    })
  }

  handleClose = () => { this.setState({ addDialog: false }) }

  render() {
    let i = 0;
    return (
      <div style={{padding: '0.5%'}}>
        <Loading load={this.state.load} message={this.state.message} />
        <br/>
        { this.state.requestitems.length > 0 ?
          (
            <div>
              <table width='100%' id='table'>
                <tr>
                  <th id='th'><center>Sino</center></th>
                  <th id='th'><center>Id</center></th>
                  <th id='th'><center>Requested Branch</center></th>
                  <th id='th'><center>Items</center></th>
                  <th id='th'><center>Date</center></th>
                  <th id='th'><center>View</center></th>
                </tr>
                { this.state.requestitems.map((c) => {
                    i++;
                    return (
                      <tr>
                        <td><center>{i}</center></td>
                        <td><center>{c.mid}</center></td>
                        <td><center>{c.toBranchId+'->'+c.toBranchName}</center></td>
                        <td><center>{c.items}</center></td>
                        <td><center>{c.timestamp.split(' ')[0]}</center></td>
                        <td><center><ViewRequestInItems menuPermission={this.props.menuPermission} display='show' mid={c.mid} from='requestin' display1='none' fromBranchId={c.toBranchId} /></center></td>
                      </tr>
                    )
                  })
                }
              </table>
            </div>
          ) : (<div></div>)
        }
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.addDialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Add Request</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Transfer branchOptions={this.props.branchOptions} selectedBranch={this.props.selectedBranch}
                  stocktransferedit={this.props.stocktransferedit} partcodeOption={this.props.partcodeOption}
                  buttonName={'REQUEST'} />
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

Request.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Request);
